import { Link } from 'react-router-dom';
import type { Video } from '@/mocks/videos';

interface VideoCardProps {
  video: Video;
}

export default function VideoCard({ video }: VideoCardProps) {
  return (
    <Link
      to={`/category/${video.category}`}
      className="group block cursor-pointer"
    >
      <div className="relative overflow-hidden rounded-lg aspect-video mb-3">
        <img
          src={video.thumbnail}
          alt={video.title}
          title={`${video.title} - 国产在线观看`}
          className="w-full h-full object-cover transition-transform duration-500 group-hover:scale-105"
          loading="lazy"
        />
        <div className="absolute inset-0 bg-gradient-to-t from-black/60 via-transparent to-transparent opacity-0 group-hover:opacity-100 transition-opacity duration-300"></div>
        <div className="absolute top-2 left-2">
          <span className="inline-block px-2 py-0.5 rounded text-xs font-medium bg-primary-500 text-background-50">
            {video.rating}
          </span>
        </div>
        <div className="absolute bottom-2 right-2">
          <span className="inline-block px-2 py-0.5 rounded text-xs bg-black/70 text-background-50">
            {video.duration}
          </span>
        </div>
        {video.isNew && (
          <div className="absolute top-2 right-2">
            <span className="inline-block px-2 py-0.5 rounded text-xs font-medium bg-accent-500 text-background-50">
              新
            </span>
          </div>
        )}
        <div className="absolute inset-0 flex items-center justify-center opacity-0 group-hover:opacity-100 transition-opacity duration-300">
          <span className="w-12 h-12 flex items-center justify-center rounded-full bg-primary-500/90 text-background-50">
            <i className="ri-play-fill text-xl ml-0.5"></i>
          </span>
        </div>
      </div>
      <h3 className="font-heading font-semibold text-sm text-foreground-950 group-hover:text-primary-600 transition-colors line-clamp-1 mb-1">
        {video.title}
      </h3>
      <div className="flex items-center gap-2 text-xs text-foreground-500">
        <span>{video.year}</span>
        <span className="w-0.5 h-0.5 rounded-full bg-foreground-400"></span>
        <span>{video.views}次观看</span>
      </div>
    </Link>
  );
}